import React from 'react';
import { Button } from 'core/controls/button/Button';
import { withTranslate } from 'core/translate';
import useLargeBreakpoint from '../../../hooks/useLargeBreakpoint';
import { combineClassNames } from '../../../../core/css';

const CompareSelectionButton = ({
  columns,
  activeIndex,
  onSelect,
  translate,
  isFeatures,
  analyticsKey,
  headers,
  itemDescription,
}) => {
  const CAPABILITIES = 'compare capabilities';
  const TRIMS = 'compare trims';
  const BODY = 'compare body';
  const currentColumn = columns[activeIndex];
  let selectionAnalyticsKey;
  if (analyticsKey === CAPABILITIES) {
    selectionAnalyticsKey =
      analyticsKey + ':' + currentColumn?.data?.engineDescription;
  } else if (analyticsKey === TRIMS) {
    selectionAnalyticsKey = analyticsKey + ':' + currentColumn?.data?.trimName;
  } else if (analyticsKey === BODY) {
    selectionAnalyticsKey =
      analyticsKey + ':' + currentColumn?.data?.description;
  } else {
    selectionAnalyticsKey = analyticsKey;
  }

  const getButtonInfo = () => {
    if (isFeatures && currentColumn?.selectionLink) {
      return {
        buttonLabel: translate('build.v3'),
        buttonProps: {
          as: 'a',
          href: currentColumn.selectionLink,
        },
      };
    }
    return {
      buttonLabel: translate('select'),
      buttonProps: {
        onClick: () => onSelect(currentColumn),
      },
    };
  };

  const { buttonLabel, buttonProps } = getButtonInfo();

  return (
    <Button
      {...buttonProps}
      disabled={currentColumn?.data?.disabled}
      className={combineClassNames(
        'compare-footer__button',
        'stat-button-link'
      )}
      primary
      data-dtm={selectionAnalyticsKey}
      aria-label={translate('compare.select.button.aria.v3', {
        trim: headers[activeIndex]?.primaryText,
        itemDescription,
      })}>
      {buttonLabel}
    </Button>
  );
};

const CompareFooter = (props) => {
  const isAtLeastLarge = useLargeBreakpoint();
  const { columnOptions, ...rest } = props;
  return (
    <div className="compare-footer">
      {isAtLeastLarge ? <div className="grid-placeholder" /> : null}
      {columnOptions.map(({ activeIndex }, i) => {
        return (
          <CompareSelectionButton
            {...rest}
            key={i}
            activeIndex={activeIndex}
            index={i}
          />
        );
      })}
    </div>
  );
};

export default withTranslate(CompareFooter);
